import PropTypes from 'prop-types'
import { useDrop } from "react-dnd"

import { Badge, cn, List, ListItem } from 'twyne-new.ui';

import useMaxLength from '@/components/hooks/useMaxLength';
import TextTruncated from "@Components/TextTruncated"

import Draggable from "./Draggable"
import { Icons, PageDetails, TYPE_ALAIASES } from "./utils"

function PageItem({ data }) {
  const { id, name, type, active } = data

  const { ref, maxLength } = useMaxLength()

  return <ListItem className={cn(!active && "twy-bg-base", 'cursor-move')}>
    <div className='flex justify-between w-full items-center'>
      <div className='flex flex-col gap-1 w-full'>
        <div className='twy-text-base-accent' ref={ref}>
          <TextTruncated maxLength={maxLength} id={`label-page-item-${id}`} placement='bottom' className='twy-text-base-accent'>
            {`[#${id}] ${name}`}
          </TextTruncated>
        </div>
        <PageDetails data={data} />
      </div>
      <div className='flex items-center gap-1'>
        <Icons page={data} />
        <Badge className="lowercase" variant='outline'>
          {TYPE_ALAIASES[type]?.label}
        </Badge>
      </div>
    </div>
  </ListItem>
}
export default function PagesPallete({ items, onChange }) {
  const [, drop] = useDrop(() => ({
    accept: 'page-item',
    drop: item => onChange(item.data),
  }))

  return <>
    <div className='pr-2'>
      <div ref={drop} className="h-[calc(100vh-33rem)] overflow-y-scroll pr-2 mr-[-4px]">
        <List border className='p-0!'>
          {items.map((page, index) => <Draggable type="page-item" origin="available" node="available" index={index} key={page.id || `${page.name}-${index}`} data={page}>
            <PageItem data={page} />
          </Draggable>)}
        </List>
      </div>
    </div>
  </>
}

PagesPallete.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
};
